"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const CursorDrawingLayerStateEnum = Object.freeze({
    CURSOR: "cursor",
    POINTER: "pointer",
    LINE: "line",
    RECTANGLE: "rectangle",
    POLYGON: "designer",
    SELECTOR: "dotted_box",
    ELIPSE: "circle"
});
const _default = CursorDrawingLayerStateEnum;
